// extracted by mini-css-extract-plugin
export default {"logo":"Nav_logo__QR8zV","nav__form":"Nav_nav__form__8wfRK","nav":"Nav_nav__XCV7F","nav__links":"Nav_nav__links__R7FNU","links":"Nav_links__CTxp-"};